// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'
import { epochToYYYYMMDD } from 'helpers/timeConversion'
import { getBWandTxPowerMax } from '../common'
import { castToString } from 'helpers/reduxFormFunctions'

const prepData = (arr, unitType) => (
  arr.map(d => {
    // for display purposes, we actually want to treat
    // favoriteRadioCode as the radioCode
    if (d.radioFavorite) {
      d.radioCode = d.radioFavorite.favoriteRadioCode
    }

    d.radioFamilyName = castToString(d.radioFamilyName)

    // show the modulation description for fixed radios (if there is one)
    // and just say 'see radio' for adaptive radios.
    d.modulationDescription = (
      d.modulations.length > 1
        ? 'See radio details'
        : castToString(d.modulations[0].modulationDescription) || 'N/A'
    )

    // First Modulation (noun) "enabled modulation with the highest throughput"
    // Since modulations are ordered by greatest throughput to least,
    // just find the first enabled modulation and you got it!
    // radioModulations.find(m => m.enabled) supports not only regular radios but also radio favorites
    // since radio favorites can have any modulations disabled for a radio.
    const {
      modulationScheme,
      modelNumber,
      rxThreshold,
    } = d.modulations.find(m => m.enabled)

    d.modulationSchemeDescription = makeModulationSchemeLabel(modulationScheme)
    d.rxThreshold = castToString(rxThreshold)

    // this is a compound value of the model number, the architecture and the power type.
    // only the model number is a required value in db.
    const architecture = castToString(d.architecture)
    const powerType = castToString(d.powerType)
    d.modelNumberConcatenated = `${modelNumber} ${architecture} ${powerType}`

    // bandwidth and txPowerMax aren't necessarily the First Modulation.
    // rather the greatest of these values among all modulations for this radio.
    const { bandwidth, txPowerMax } = getBWandTxPowerMax(d.modulations)
    d.bandwidth = bandwidth
    d.txPowerMax = txPowerMax

    // frequency range of the radio
    d.frequency = `${d.loFrequency} - ${d.hiFrequency}`

    // replace epoch date with YYYY/MM/DD
    d.specDate = epochToYYYYMMDD(d.specDate) || 'n/a'

    // in case radio favorites are ever supported here, in place of using radioId
    // (which a single radioId can have multiple favorites)
    // radioCode will be unique in both scenarios.
    d.uniqueId = 'radioCode'
    return d
  })
)

export default prepData
